import * as z from "zod";
import { draftResultSchema } from "./common";

/**
 * Copies a published version into the draft; publishing it is a separate
 * step. A draft changed since `draftRevision` is a conflict.
 */
export const restoreVersion = {
  name: "restoreVersion" as const,
  input: z.object({
    id: z.string(),
    version: z.number().int(),
    /** The draftRevision the editor loaded or last saved. */
    draftRevision: z.string(),
  }),
  output: draftResultSchema,
};
